import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ pageRange = 8 }) => {
  const height = 41 * (pageRange + 1);
  const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
    let yStrip = ind ? 41 * ind + 8 : 12;

    if (ind === 0) {
      yStrip = 20;
    } else if (ind === 1) {
      yStrip = 81;
    } else {
      yStrip = 41 * (ind - 1) + 81;
    }

    return (
      <React.Fragment key={ind}>
        {ind ? (
          <>
            <rect x="35" y={yStrip} rx="3" ry="3" width="111" height="12" />
            <rect x="280" y={yStrip} rx="3" ry="3" width="150" height="12" />
            <rect x="965" y={yStrip} rx="3" ry="3" width="70" height="12" />
            <rect x="1148" y={yStrip} rx="3" ry="3" width="10" height="12" />
          </>
        ) : (
          <>
            <rect x="35" y={yStrip + 8} rx="3" ry="3" width="111" height="12" />
            <rect x="280" y={yStrip + 8} rx="3" ry="3" width="100" height="12" />
            <rect x="965" y={yStrip} rx="3" ry="3" width="100" height="24" />
            <rect x="1148" y={yStrip + 8} rx="3" ry="3" width="78" height="12" />
          </>
        )}
      </React.Fragment>
    );
  });

  return (
    <ContentLoader
      speed={2}
      width={1278}
      height={435}
      viewBox={`0 0 1278 435`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <>
        {body}
        <rect x="35" y="415" rx="3" ry="3" width="60" height="12" />
        <rect x="965" y="415" rx="3" ry="3" width="100" height="12" />
        <rect x="1148" y="415" rx="3" ry="3" width="10" height="12" />
      </>
    </ContentLoader>
  );
};

export default Loader;
